import { useEffect, useRef, useState } from 'react';
import { depoimentosData } from '@/mocks/homeData';

export default function Experiencias() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="experiencias"
      ref={ref}
      className="bg-white py-28 md:py-36 lg:py-44 border-t border-black/[0.04]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight text-black tracking-tight text-center mb-14 md:mb-20">
          {depoimentosData.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {depoimentosData.items.map((item, i) => (
            <div
              key={item.author}
              className={`bg-brand-off-white p-8 md:p-10 rounded-sm ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              } transition-all duration-700 ease-editorial`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <p className="font-body text-base md:text-lg font-light text-brand-gray-dark leading-[1.7] mb-8">
                "{item.text}"
              </p>
              <p className="font-body text-sm font-normal text-marrom tracking-wide">
                {item.author}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}